export interface IPitchAngles {
    [key: string]: number[]
}

export const pitchAngle: IPitchAngles = {
    'WTG000': [114.0, 115.7, 111.0, 5.05],
    'WTG001': [114.0, 115.7, 111.0, 5.05],
    'WTG002': [114.0, 115.7, 111.0, 5.05],
    'WTG003': [114.0, 115.7, 111.0, 5.05],
    'WTG004': [114.0, 115.7, 111.0, 5.05],
    'WTG005': [114.0, 115.7, 111.0, 5.05],
    'WTG006': [114.0, 115.7, 111.0, 5.05],
    'WTG007': [114.0, 115.7, 111.0, 5.05],
    'WTG008': [114.0, 115.7, 111.0, 5.05],
    'WTG009': [114.0, 115.7, 111.0, 5.05],
    'WTG010': [114.0, 115.7, 111.0, 5.05],
    'WTG011': [114.0, 115.7, 111.0, 5.05],
    'WTG012': [114.0, 115.7, 111.0, 5.05],
    'WTG013': [114.0, 115.7, 111.0, 5.05],
    'WTG014': [114.0, 115.7, 111.0, 5.05],
    'WTG015': [114.0, 115.7, 111.0, 5.05],
    'WTG016': [114.0, 115.7, 111.0, 5.05],
    'WTG017': [114.0, 115.7, 111.0, 5.05],
    'WTG018': [114.0, 115.7, 111.0, 5.05],
    'WTG019': [114.0, 115.7, 111.0, 5.05],
    'WTG020': [114.0, 115.7, 111.0, 5.05],
    'WTG021': [114.0, 115.7, 111.0, 5.05],
    'WTG022': [114.0, 115.7, 111.0, 5.05],
    'WTG023': [114.0, 115.7, 111.0, 5.05],
    'WTG024': [114.0, 115.7, 111.0, 5.05],
    'WTG025': [114.0, 115.7, 111.0, 5.05],
    'WTG026': [114.0, 115.7, 111.0, 5.05],
    'WTG027': [114.0, 115.7, 111.0, 5.05],
    'WTG028': [114.0, 115.7, 111.0, 5.05],
    'WTG029': [114.0, 115.7, 111.0, 5.05],
    'WTG030': [114.0, 115.7, 111.0, 5.05],
    'WTG031': [114.0, 115.7, 111.0, 5.05],
    'WTG032': [114.0, 115.7, 111.0, 5.05],
    'WTG033': [114.0, 115.7, 111.0, 5.05],
    'WTG034': [114.0, 115.7, 111.0, 5.05],
    'WTG035': [114.0, 115.7, 111.0, 5.05],
    'WTG036': [114.0, 115.7, 111.0, 5.05],
    'WTG037': [114.0, 115.7, 111.0, 5.05],
    'WTG038': [114.0, 115.7, 111.0, 5.05],
    'WTG039': [114.0, 115.7, 111.0, 5.05],
    'WTG040': [114.0, 115.7, 111.0, 5.05],
    'WTG041': [114.0, 115.7, 111.0, 5.05],
    'WTG042': [114.0, 115.7, 111.0, 5.05],
    'WTG043': [114.0, 115.7, 111.0, 5.05],
    'WTG044': [114.0, 115.7, 111.0, 5.05],
    'WTG045': [114.0, 115.7, 111.0, 5.05],
    'WTG046': [114.0, 115.7, 111.0, 5.05],
    'WTG047': [114.0, 115.7, 111.0, 5.05],
    'WTG048': [114.0, 115.7, 111.0, 5.05],
    'WTG049': [114.0, 115.7, 111.0, 5.05],
    'WTG050': [114.0, 115.7, 111.0, 5.05],
    'WTG051': [114.0, 115.7, 111.0, 5.05],
    'WTG052': [114.0, 115.7, 111.0, 5.05],
    'WTG053': [114.0, 115.7, 111.0, 5.05],
    'WTG054': [114.0, 115.7, 111.0, 5.05],
    'WTG055': [114.0, 115.7, 111.0, 5.05],
    'WTG056': [114.0, 115.7, 111.0, 5.05],
    'WTG057': [114.0, 115.7, 111.0, 5.05],
    'WTG058': [114.0, 115.7, 111.0, 5.05],
    'WTG059': [114.0, 115.7, 111.0, 5.05],
    'WTG060': [114.0, 115.7, 111.0, 5.05],
    'WTG061': [114.0, 115.7, 111.0, 5.05],
    'WTG062': [114.0, 115.7, 111.0, 5.05],
    'WTG063': [114.0, 115.7, 111.0, 5.05],
    'WTG064': [114.0, 115.7, 111.0, 5.05],
    'WTG065': [114.0, 115.7, 111.0, 5.05],
    'WTG066': [114.0, 115.7, 111.0, 5.05],
    'WTG067': [114.0, 115.7, 111.0, 5.05],
    'WTG068': [114.0, 115.7, 111.0, 5.05],
    'WTG069': [114.0, 115.7, 111.0, 5.05],
    'WTG070': [114.0, 115.7, 111.0, 5.05],
    'WTG071': [114.0, 115.7, 111.0, 5.05],
}
